// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomScrollbar_scrollbar__Z1HKB {
  position: fixed;
  top: 0;
  right: 0.18rem;
  width: 0.32rem;
  height: 100vh;
  z-index: 4000;
  display: flex;
  justify-content: center;
  padding: 0.6rem 0;
  background: transparent;
  opacity: 0;
  transition: opacity 0.28s ease;
}

.CustomScrollbar_active__v--Lg {
  opacity: 1;
}

.CustomScrollbar_thumb__tI6zI {
  width: 100%;
  border-radius: 999px;
  background: rgba(77, 163, 255, 0.78);
  cursor: grab;
  transition: background-color 0.2s ease;
}

.CustomScrollbar_thumb__tI6zI:hover {
  background: rgba(77, 163, 255, 0.95);
}

.CustomScrollbar_thumb__tI6zI:active {
  cursor: grabbing;
}

@media (max-width: 768px) {
  .CustomScrollbar_scrollbar__Z1HKB {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomScrollbar.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,cAAc;EACd,cAAc;EACd,aAAa;EACb,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".scrollbar {\n  position: fixed;\n  top: 0;\n  right: 0.18rem;\n  width: 0.32rem;\n  height: 100vh;\n  z-index: 4000;\n  display: flex;\n  justify-content: center;\n  padding: 0.6rem 0;\n  background: transparent;\n  opacity: 0;\n  transition: opacity 0.28s ease;\n}\n\n.active {\n  opacity: 1;\n}\n\n.thumb {\n  width: 100%;\n  border-radius: 999px;\n  background: rgba(77, 163, 255, 0.78);\n  cursor: grab;\n  transition: background-color 0.2s ease;\n}\n\n.thumb:hover {\n  background: rgba(77, 163, 255, 0.95);\n}\n\n.thumb:active {\n  cursor: grabbing;\n}\n\n@media (max-width: 768px) {\n  .scrollbar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbar": `CustomScrollbar_scrollbar__Z1HKB`,
	"active": `CustomScrollbar_active__v--Lg`,
	"thumb": `CustomScrollbar_thumb__tI6zI`
};
export default ___CSS_LOADER_EXPORT___;
